import { lazy } from "react";
import Page from "@jumbo/shared/Page"; // Keep shared layout eagerly loaded
import AccessMiddleware from "./middleware/auth/AccessMiddleware"; // Keep middleware eagerly loaded
import { OTHER_GOODS_RAW_ORDER } from "../utils/constants/routeConstant"; // Constants stay eager
import { LoadablePage } from "app/utils/loadablePage";

// Lazy-loaded components
const OtherGoodsInventoryList = lazy(() => import("app/pages/Inventory/other goods/ListOtherGoods"));
const AddOtherGoodsStock = lazy(() => import("app/pages/Inventory/other goods/AddOtherGoods"));
const EditOtherGoodsStock = lazy(() => import("app/pages/Inventory/other goods/EditOtherGoods"));
const ViewDetails = lazy(() => import("app/pages/Inventory/other goods/ListOtherGoods/Approval/ViewDetails"));
const IssueRawOrderOtherGoods = lazy(() => import("app/pages/Inventory/other goods/IssueRawOrder"));


export const otherGoodsRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "other_goods_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "inventory/other-goods",
        element: (
          LoadablePage(OtherGoodsInventoryList)
        ),
      },

      {
        path: "inventory/other-goods/add",
        element: (
          LoadablePage(AddOtherGoodsStock)
        ),
      },
      {
        path: "inventory/other-goods/edit",
        element: (
          LoadablePage(EditOtherGoodsStock)
        ),
      },
      {
        path: "/inventory/otherGoods-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails)
      },
      {
        path: OTHER_GOODS_RAW_ORDER,
        element: (
          LoadablePage(IssueRawOrderOtherGoods)
        ),
      },
    ],
  },
];
